/**
 * Copyright 2024 The Ground Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { HeaderModule } from 'app/components/shared/header/header.module';
import { TermsComponent } from 'app/components/terms/terms.component';

@NgModule({
  declarations: [TermsComponent],
  imports: [
    CommonModule,
    FormsModule,
    HeaderModule,
    RouterModule,
    MatButton,
    MatCheckboxModule,
    MatIcon,
  ],
  exports: [TermsComponent],
})
export class TermsModule {}
